import { Dispatch } from "redux";
import { investmentAdminApi } from "./api";
import { investmentAdminActions } from "./slice";

export const getInvestmentAdmin = () => (dispatch: Dispatch) => {
  investmentAdminApi.get().then(({ data }) => {
    dispatch(investmentAdminActions.setData(data.list));
  });
};
